// src/services/announcementService.js

import axiosInstance from "../api/axiosInstance";

/**
 * Dev logger (hidden in production)
 */

/**
 * Common request handler
 */
const handleRequest = async (requestFn) => {

 try {



 const response = await requestFn();



 return {
 success: true,
 data: response.data,
 status: response.status
 };

 } catch (error) {



 return {
 success: false,
 data: null,
 status: error?.response?.status,
 message:
 error?.response?.data?.message ||
 error.message ||
 "Something went wrong"
 };

 }

};


/* ===============================
 PUBLIC ANNOUNCEMENTS
================================ */

/**
 * Fetch active announcements
 */
export const fetchActiveAnnouncements = () =>
 handleRequest(() =>
 axiosInstance.get("/announcements/active")
 );
